/* Reformly Home — rail scroll-position indicator, for rails that are NOT
   Swipers.

   WHAT USED TO BE HERE. This file painted the 2px bar under every rail by
   hand, reproducing the export's two derived values off the rail's scroll
   position:

     railThumbW  Math.min(100, visible / total * 100)   -> thumb width, %
     railThumbX  progress * (100 / thumbW) * ...        -> thumb offset

   The product rails (Bestsellers, Pilates Socks, Bundles) no longer need
   that. They are Swipers now — see sections/reformly-home-rail.liquid — and
   their bar is Swiper's own Scrollbar module with `dragSize: 'auto'`, which
   is the same `trackSize * (size / virtualSize)` formula. Swiper writes the
   width and transform inline, tracks the drag frame by frame, and the bar
   answers a drag instead of only reporting one. Reimplementing any of that
   here would be strictly worse code.

   WHAT IS STILL HERE, and why it is not dead. The category tiles
   (sections/reformly-home-categories.liquid) are a rail only below 900 and a
   CSS grid above it, where the bar is hidden outright. Swiper would have to
   be disabled per breakpoint and its flex wrapper overridden back to a grid,
   to buy mouse drag at widths that have no rail — so that section keeps the
   native scroller, and keeps this.

   The three data attributes stay the contract for both kinds: a new rail that
   does not opt into Swiper still gets a working bar rather than a dead one.
*/
(function () {
  var rails = document.querySelectorAll('[data-rhm-rail]');
  if (!rails.length) return;

  Array.prototype.forEach.call(rails, function (rail) {
    /* A Swiper rail paints its own bar. Checked by attribute rather than by
       looking for the instance, which does not exist yet: reformly-bp-swiper.js
       defers every carousel behind an IntersectionObserver. */
    if (rail.hasAttribute('data-bp-swiper')) return;

    var sec = rail.closest('[data-rhm-rail-sec]');
    var thumb = sec && sec.querySelector('[data-rhm-rail-thumb]');
    if (!thumb) return;

    var queued = false;

    function paint() {
      queued = false;

      var total = rail.scrollWidth;
      var visible = rail.clientWidth;

      /* Nothing to scroll: a full-width thumb reads as "all of it is here",
         which is correct and also what the export shows. */
      if (total <= visible + 1) {
        thumb.style.setProperty('--rhm-thumb-w', '100%');
        thumb.style.setProperty('--rhm-thumb-x', '0');
        return;
      }

      var w = Math.min(100, (visible / total) * 100);
      var travel = total - visible;
      var progress = rail.scrollLeft / travel;          /* 0 .. 1 */

      /* The offset is expressed in multiples of the thumb's OWN width,
         because translate percentages resolve against the element, not the
         track. At progress 1 the thumb's right edge must sit on the track's
         right edge, so it travels (100 / w - 1) of its own widths. */
      var x = progress * (100 / w - 1) * 100;

      thumb.style.setProperty('--rhm-thumb-w', w + '%');
      thumb.style.setProperty('--rhm-thumb-x', x + '%');
    }

    /* rAF-coalesced: scroll fires far more often than a frame, and this reads
       scrollWidth/clientWidth, which are layout-forcing properties. Reading
       them synchronously on every scroll event is the pattern that shows up as
       a long task on a mid-range phone. */
    function onScroll() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(paint);
    }

    rail.addEventListener('scroll', onScroll, { passive: true });

    /* Card widths are percentage-based and step at 700 and 1100, so both the
       thumb width and the travel change on resize. ResizeObserver rather than
       a window listener: it also fires when the rail changes size without the
       window doing so, which happens when a collection loads in the editor. */
    if ('ResizeObserver' in window) {
      new ResizeObserver(onScroll).observe(rail);
    } else {
      window.addEventListener('resize', onScroll);
    }

    paint();
  });
})();
